import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: "949455f8-3ea0-468a-8c4d-a116cf22f3c4",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "e3a5c5d4-fc18-4009-bc50-e5824bd184ac",
      type: "Graphics",
      name: "overlay",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "949455f8-3ea0-468a-8c4d-a116cf22f3c4",
      bake: false,
      commands: [
        {
          id: "8bdb4332-945e-47be-8a12-6d344807af20",
          type: "beginFill",
          color: 0,
          alpha: 0.7
        },
        {
          id: "43e93b1f-eb45-45db-a272-4a5d2f98022b",
          type: "drawRect",
          x: -2000,
          y: -2000,
          width: 4000,
          height: 4000
        }
      ],
      data: ""
    },
    {
      id: "938194f5-d073-44b0-9f70-df8a0525847e",
      type: "Container",
      name: "dialogContainer",
      nameSpace: "",
      className: "",
      x: -6,
      y: -238,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "949455f8-3ea0-468a-8c4d-a116cf22f3c4",
      data: ""
    },
    {
      id: "45259a08-bb33-4723-b308-a45e68c5a0b3",
      type: "Container",
      name: "boostersContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "949455f8-3ea0-468a-8c4d-a116cf22f3c4",
      data: ""
    },
    {
      id: "744fabd6-ec47-4606-b7dc-a33134a2b6c9",
      type: "Container",
      name: "arrowsContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "949455f8-3ea0-468a-8c4d-a116cf22f3c4",
      data: ""
    },
    {
      id: "3209712c-312c-48c1-870b-61561a488654",
      type: "NineSlicePlane",
      name: "dialogBg",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 305,
        y: 91
      },
      width: 610,
      height: 182,
      leftWidth: 38,
      topHeight: 80,
      rightWidth: 37,
      bottomHeight: 86,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "info_box",
      parent: "938194f5-d073-44b0-9f70-df8a0525847e",
      data: ""
    },
    {
      id: "9a42b115-1c82-4956-a1d8-edcd193b5ff7",
      type: "Text",
      name: "dialogText",
      nameSpace: "",
      className: "",
      x: 0,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "YouUnlockedABooster",
      localize: true,
      maxWidth: 523,
      maxHeight: 149,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#ba372b",
        stroke: "black",
        strokeThickness: 0,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "938194f5-d073-44b0-9f70-df8a0525847e",
      data: ""
    }
  ]
} as const;

export class PreBoosterTutorialLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  overlay: GameObject<PIXI.Graphics>;
  dialogContainer: GameObject<PIXI.Container>;
  dialogBg: GameObject<PIXI.NineSlicePlane>;
  dialogText: GameObject<PIXI.Text>;
  boostersContainer: GameObject<PIXI.Container>;
  arrowsContainer: GameObject<PIXI.Container>;

  constructor() {
    populate(this, raw);
  }
}
